import React, { useEffect } from "react";
import Sec4Description from "../components/exploration/sec4description";
import HeadingSample from "../components/utility/headingSample";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import ExplorationHighlights from "../components/exploration/explorationHighlights";
import DisplayAmount from "../components/Home/section4/displayAmount";

const Exploration: React.FC = () => {

    // -------------sec1setting------
    const sec1Subtitle = " Exploration & Results";
    const sec1Title = [
        " Mineralex SL",
        "#3CCDB3",
    ];
    // ---------sec2setting--------
    const sec2title = "extensive studies by leading geological consultants";
    const sec2subtitle = "comprehensive exploration";
    const sec2contexts = [
        "Advanced geophysical techniques such as Gradient Array and High-Resolution Induced Polarization (HIRIP) surveys, Fire Assay Analysis, Ultra-Ground Penetrating Radar and more were adopted together with Trenching, Pitting, Drilling and Trial Mining. These advanced methods have been instrumental in identifying mineral-rich zones deep within the bedrock, thereby guiding targeted exploration efforts for Gold, Coltan, Rare Earth Elements (REE), Tin, and Diamonds. The utilization of these advanced techniques underscores the company's commitment to employing cutting-edge technology in its exploration endeavors.",
    ];
    // -------------sec4setting---------
    const sec4imgsize = "80px";
    const Ref = useRef(null);
    const InView = useInView(Ref, { once: false, amount: 0.2 });
    return (
        <div className="w-full  flex flex-col items-center justify-center bg-white box-border overflow-hidden">

            {/* ------------section1----------- */}
            <div id="exploration_Home" className="h-[700px] w-[100vw]  bg-[url('../public/exploration/section1.svg')] inset-0  bg-black/30  bg-blend-overlay  bg-cover bg-center ">
                <HeadingSample subtitle={sec1Subtitle} title={sec1Title} />
            </div>
            {/* -----------section2-------- */}
            <div id="presentation" className="w-full min-h-screen bg-[url('../public/exploration/section2.svg')] bg-cover bg-center  flex flex-col justify-center items-center md:items-start gap-4 p-2 sm:p-10">
                <motion.div
                    ref={Ref}
                    initial="hidden"
                    animate={InView ? "visible" : "hidden"}
                    variants={{
                        hidden: { opacity: 0, y: 30 },
                        visible: { opacity: 1, y: 0, transition: { duration: 0.5, type: "spring", bounce: 0 } },
                    }}
                    className="contain w-full max-w-[720px] h-auto  bg-[url('../public/home/Vector2.png')] bg-cover bg-center  flex flex-col items-start justify-center  gap-4 border-l-[19px] border-[#3CCDB3] p-2 pt-8 pb-24 z-10 relative">
                    <div className="hidden md:block w-[68x] h-[68px] absolute right-5 top-3">
                        <img src="/exploration/section2panel_img.svg" alt="blue logo" className="w-full h-auto " />
                    </div>
                    <div className="w-full sm:w-3/4 border-l-2 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[20px] font-bungeeinline">{sec2title}</div>
                    <div className="font-normal text-[#3CCDB3] font-bungeeinline text-3xl sm:text-4xl uppercase ">{sec2subtitle}</div>
                    {sec2contexts.map((context, index) => (
                        <div key={index}>
                            {context}
                        </div>
                    ))}
                </motion.div>
            </div>

            {/* --------------section3------ */}
            <div id="mineral_Deposits" className="w-full bg-[#FAD2A1] flex flex-col justify-center items-center  sm:gap-6">
                <div className="w-full flex flex-col md:flex-row justify-center md:justify-start p-4 md:p-10">
                    <div className="border-l-2 border-[#3CCDB3] px-1 md:px-2 text-center md:text-left text-[#3CCDB3] font-normal text-[20px] sm:text-[36px] font-bungeeinline">
                        High-value mineral deposits
                    </div>
                </div>
                <div className="w-full max-w-7xl  flex flex-col lg:flex-row justify-center items-center gap-4 p-4">
                    <div className="flex flex-col sm:flex-row justify-center items-center sm:items-start gap-4 w-full border-b-2 border-gray-500 pb-4 md:w-auto">
                        <DisplayAmount value={{ text: "+$20M", text_color: "#3CCDB3", font_size: "50px" }} explanation={{ text: "Invested in Exploration ", text_color: "#000000", font_size: "22px" }} />
                        <DisplayAmount value={{ text: "+$10B", text_color: "#3CCDB3", font_size: "50px" }} explanation={{ text: "Deposits Value", text_color: "#000000", font_size: "22px" }} />
                    </div>
                    <div className="w-full grid gird-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                        <div className="flex flex-col justify-center items-center gap-4 w-full border-b-2 border-gray-400 pb-4 md:w-auto">
                            <div className="text-black text-center font-bungeeinline text-[32px] sm:text-[42px] font-normal leading-[59px]">
                                GOLD
                            </div>
                            <DisplayAmount value={{ text: "2,100,000", text_color: "#3CCDB3", font_size: "36px" }} explanation={{ text: "OZ inferred", text_color: "#000000", font_size: "22px" }} />
                            <DisplayAmount value={{ text: "1.8–3.5 g/t.", text_color: "#3CCDB3", font_size: "36px" }} explanation={{ text: "Grades Ranging", text_color: "#000000", font_size: "22px" }} />
                        </div>

                        <div className="flex flex-col justify-center items-center gap-4 w-full border-b-2 border-gray-400 pb-4 md:w-auto">
                            <div className="text-black text-center font-bungeeinline text-[32px] sm:text-[42px] font-normal leading-[59px]">
                                COLTAN
                            </div>
                            <DisplayAmount value={{ text: "190,000", text_color: "#3CCDB3", font_size: "36px" }} explanation={{ text: "Tons inferred", text_color: "#000000", font_size: "22px" }} />
                            <DisplayAmount value={{ text: "25–30% Ta₂O₅", text_color: "#3CCDB3", font_size: "36px" }} explanation={{ text: "Grades Ranging ", text_color: "#000000", font_size: "22px" }} />
                        </div>

                        <div className="flex flex-col justify-center items-center gap-4 w-full border-b-2 border-gray-400 pb-4 md:w-auto">
                            <div className="text-black text-center font-bungeeinline text-[32px] sm:text-[42px] font-normal leading-[59px]">
                                TIN
                            </div>
                            <DisplayAmount value={{ text: "18,000", text_color: "#3CCDB3", font_size: "36px" }} explanation={{ text: "Tons", text_color: "#000000", font_size: "22px" }} />
                            <DisplayAmount value={{ text: "20.2% SnO₂", text_color: "#3CCDB3", font_size: "36px" }} explanation={{ text: "Grades Ranging ", text_color: "#000000", font_size: "22px" }} />
                        </div>

                        <div className="flex flex-col justify-center items-center gap-4 w-full border-b-2 border-gray-400 pb-4 md:w-auto">
                            <div className="text-black text-center font-bungeeinline text-[32px] sm:text-[42px] font-normal leading-[59px]">
                                REE
                            </div>
                            <DisplayAmount value={{ text: "9000", text_color: "#3CCDB3", font_size: "36px" }} explanation={{ text: "Tons", text_color: "#000000", font_size: "22px" }} />
                            <DisplayAmount value={{ text: "0.1% TREO", text_color: "#3CCDB3", font_size: "36px" }} explanation={{ text: "Grades Ranging ", text_color: "#000000", font_size: "22px" }} />
                        </div>
                    </div>
                </div>

            </div>


            <div id="work_Highlights" className="w-full h-auto bg-[#172B6B] flex flex-col justify-center  items-center p-6 sm:p-10 gap-10">
                <div className="w-full flex flex-row justify-center md:justify-start">
                    <div className="border-l-2 border-[#F8D835] px-1 md:px-2 text-center md:text-left  text-[#F8D835] font-normal text-[20px] sm:text-[36px] font-bungeeinline">
                        WORK DONE HIGHLIGHTS
                    </div>
                </div>

                <div className="w-full h-auto grid grid-rows-4 sm:grid-cols-2 gap-2 lg:gap-x-24 lg:px-24">
                    <Sec4Description imgsource="/exploration/sec4_1.svg" imgsize={sec4imgsize} contexts="Over 10,000 soil samples, 2,200 rock samples and 2,730 stream sediment samples" fontColor="white" />
                    <Sec4Description imgsource="/exploration/sec4_2.svg" imgsize={sec4imgsize} contexts="Ultra Ground Penetrating Radar (UGPR) - 25-line kilometers" fontColor="white" />
                    <Sec4Description imgsource="/exploration/sec4_3.svg" imgsize={sec4imgsize} contexts="High-Resolution Induced Polarization - 25-line kilometers" fontColor="white" />
                    <Sec4Description imgsource="/exploration/sec4_4.svg" imgsize={sec4imgsize} contexts="193 pitsin depth of 1 to 3 meters and 1.5 to 2 meters wide" fontColor="white" />
                    <Sec4Description imgsource="/exploration/sec4_5.svg" imgsize={sec4imgsize} contexts="15 trenches across 3,262 meters. Width of 1.5 meters and depths of 1.5 to 2 meters" fontColor="white" />
                    <Sec4Description imgsource="/exploration/sec4_6.svg" imgsize={sec4imgsize} contexts="12 diamond drill holes, 1,799 meters, to depths of up to 250 meters, with hole spacing of 200–300 meters and inclinations of -50˚ to -80˚." fontColor="white" />
                    <Sec4Description imgsource="/exploration/sec4_7.svg" imgsize={sec4imgsize} contexts="23 Bulk sampling and 10 trial mining pits, depths up to 12 meters, excavations of 10x10 meters. Over 5,000 cubic meters of material was processed" fontColor="white" />

                </div>
            </div>

            {/* -----------------section4--------- */}

            <ExplorationHighlights />
            {/* -------section5-- */}
            <div id="future_plans" className="w-full h-auto flex flex-col justify-center items-center p-6 sm:p-10 gap-4">
             
                    <div className="w-full border-l-2 border-[#172B6B] px-2 text-[#172B6B] font-bold text-[22px] sm:text-[30px] font-bungeeinline uppercase">
                        MINERALEX SL future plans
                    </div>
                
                <div className="w-full flex flex-col justify-center items-center gap-4">
                    <img src="/exploration/future_plan1.png" alt="future_plan1" className="w-full h-auto max-w-3xl" />
                    <img src="/exploration/future_plan2.png" alt="future_plan2" className="w-full h-auto max-w-3xl" />

                </div>
            </div>

        </div>

    );
};

export default Exploration;